<ng-container [formGroup]="form">
        <div [froalaEditor]="editorOptions"
            [(froalaModel)]="model"
            (froalaModelChange)="change()"
            [formControlName]="id"></div>
</ng-container>
